export const unMask = (value: string, pattern: RegExp) => value.replace(pattern, '')
